/**
 * Адреса содержимого обложки общего товара (`CatalogPhotoRoutes.CoverUrl`, PHI-13b). Литерал `/api/` законен только в файлах `api/urls.ts` (eslint).
 * Идентификаторы приходят из ответов и адреса окна — кодируются. Байты фото идут через Platform (`…/content`), а не ссылкой хранилища.
 */
const BASE = '/api/platform/v1/catalog/products'

export const PLATFORM_COMMON_PHOTO_URLS = {
  /** Содержимое фотографии реестра (PHI-12): кадр берёт Platform у источника; по ключу содержимое неизменно. */
  registryContent: (productId: string, photoKey: string) => `${BASE}/${encodeURIComponent(productId)}/photo-registry/${encodeURIComponent(photoKey)}/content`,
  /** Содержимое временной загрузки («ещё нигде не лежит», PHI-6). */
  stagingContent: (productId: string, stagingId: string) => `${BASE}/${encodeURIComponent(productId)}/photos/staging/${encodeURIComponent(stagingId)}/content`,
} as const

/**
 * Обложка главного фото ОБЩЕГО товара из ответа сервера (`mainPhoto`, RP-FB70, PHI-13b): фотография реестра либо временная загрузка. Нет фото — `null`:
 * запасной вариант выбирает экран.
 */
export const commonPhotoThumbUrl = (productId: string, photo: { photoId: string; kind: 'registry' | 'staging' } | null | undefined): string | null => {
  if (photo === null || photo === undefined) return null
  return photo.kind === 'registry'
    ? PLATFORM_COMMON_PHOTO_URLS.registryContent(productId, photo.photoId)
    : PLATFORM_COMMON_PHOTO_URLS.stagingContent(productId, photo.photoId)
}
